import { defineRoute } from "src/routing/defineRoute";

/**
 * Path + typed URL builder pairs for `/libraries/product-offering-configs/*`.
 *
 * Kept separate from the route tree so `RouteUrls.ts` and pages can import paths without a cycle
 * through page `Component` imports.
 *
 * Full absolute strings (RR6 requires a child's path to start with its parent's).
 */
export const globalProductOfferingConfigsRoute = defineRoute("/libraries/product-offering-configs");
export const productOfferingConfigRoute = defineRoute(
  "/libraries/product-offering-configs/:productOfferingId/:idOrAdd",
);
export const productOfferingConfigEditRoute = defineRoute(
  "/libraries/product-offering-configs/:productOfferingId/edit/:productOfferingConfigId",
);
